import React, { useEffect, useState } from 'react';
import { Stepper, Step, StepLabel, Box } from '@mui/material';
import RequestTokenStep from './RequestTokenStep';
import VerifyTokenStep from './VerifyTokenStep';
import NewPasswordStep from './NewPasswordStep';
import { useAuth } from '../../contexts/AuthProvider';
import CustomContainer from '../../components/CustomContainer';
import PageHeader from '../../components/PageHeader';
import AppCard from '../../components/ui/AppCard';

const steps = ['E-mail', 'Código', 'Nova senha'];

export default function ResetPassword() {
    const { user } = useAuth();
    const [activeStep, setActiveStep] = useState(0);
    const [email, setEmail] = useState(user?.email || '');
    const [token, setToken] = useState('');

    // Cliente logado: prefixa o e-mail quando o contexto termina de carregar.
    useEffect(() => {
        if (user?.email && !email) setEmail(user.email);
    }, [user, email]);

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => setActiveStep((prev) => prev - 1);

    return (
        <CustomContainer>
            <Box mx="auto" my={8} sx={{ minHeight: '50vh', maxWidth: 560 }}>
                <PageHeader title="Redefinir senha" crumbs={['Redefinir senha']} />
                <AppCard>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Box mt={3}>
                    {activeStep === 0 && (
                        <RequestTokenStep
                            email={email}
                            setEmail={setEmail}
                            onSuccess={handleNext}
                            emailReadOnly={!!user?.email}
                        />
                    )}
                    {activeStep === 1 && (
                        <VerifyTokenStep
                            email={email}
                            token={token}
                            setToken={setToken}
                            onSuccess={handleNext}
                            onBack={handleBack}
                        />
                    )}
                    {activeStep === 2 && (
                        <NewPasswordStep
                            token={token}
                            onBack={handleBack}
                        />
                    )}
                </Box>
                </AppCard>
            </Box>
        </CustomContainer>
    );
}
